import {get, post} from "./index.js";

const list_variables = async () => {
    return get(`/variable/`);
}

const add_variable = async (name, type) => {
    return post(`/variable/add`, {name, type});
}

const edit_variable = async (variable) => {
    const {id, ...edit} = variable;
    return post(`/variable/${id}/edit`, edit);
}

const delete_variable = async (id) => {
    return post(`/variable/${id}/delete`);
}

export {
    list_variables,
    add_variable,
    edit_variable,
    delete_variable
}
